export const paymentConfigInfo = {
    depositToolTip: "DepositTooltip",
    advRentToolTip: "AdvRentTooltip",
    holdingFeeToolTip: "HoldingFeeTooltip",
    bondToolTip: "BondTooltip",
    householdText: "HouseholdText"
} 

export const AmenityApartmentTypeCode = 'APT'